<div class="box">
    <div class="box-title">
        {{ 'Evaluations' | translate }}
    </div>
    <div class="box-content">
        <mat-spinner *ngIf="isLoading; else boxContent" [diameter]="30"></mat-spinner>
    </div>
</div>

<ng-template #boxContent>
    <div *ngIf="evaluationAthleteData && evaluationAthleteData.length > 0">
      <mat-list>
        <mat-list-item *ngFor="let data of evaluationAthleteData" class="eval-list-item">
          <div class="list-content"> <!-- Encapsulate content in a flex container -->
            <h3 mat-line class="title">{{ data.title }}</h3>
            <mat-chip-set class="evaluation-athlete-status">
              <mat-chip *ngIf="data['evaluations_athlete'].length"
                        ngClass="{{data['evaluations_athlete'][0].status === 'opened' ? 'mat-chip-accent' : ''}}">
                {{ data['evaluations_athlete'][0].status === 'opened' ? (data['evaluations_athlete'][0].status | translate) : (data['evaluations_athlete'][0].date | date:'mediumDate') }}
              </mat-chip>
            </mat-chip-set>
            <button *ngIf="data['evaluations_athlete'].length"
                    mat-mini-fab color="none" class="action-button"
                    [matTooltip]="'EvaluationsAll' | translate"
                    [routerLink]="'/' + organization?.code + '/athletes/' + athleteUser?.id + '/evaluations/' + data['evaluations_athlete'][0].id">
              <mat-icon>arrow_right_alt</mat-icon>
            </button>
            <button *ngIf="!data['evaluations_athlete'].length"
                    mat-mini-fab color="none" class="action-button"
                    [matTooltip]="'EvaluationsAll' | translate"
                    [routerLink]="'/' + organization?.code + '/athletes/' + athleteUser?.id + '/evaluations/'">
              <mat-icon>arrow_right_alt</mat-icon>
            </button>
          </div>
        </mat-list-item>
      </mat-list>

    </div>
</ng-template>
